<template>
    <div class="post-box" :class="( post.first_post ? 'post-box-large' : '' )">
        <b-row>
            <b-col cols="12" md="8" v-if="post.first_post">
                <div class="thumb mb-2" @click="openUrl" :style="'background-image: url('+ post.image +')'"></div>
            </b-col>
            <b-col cols="12" :md="( post.first_post ? '4' : '12' )">
                <div v-if="!post.first_post" class="thumb mb-2" @click="openUrl()" :style="'background-image: url('+ post.image +')'"></div>
                <div class="inner">
                    <h4 class="mb-2 font-20"><a :href="post.url">{{ post.title }}</a></h4>
                    <div class="excerpt mb-3 font-16">
                        {{ post.excerpt }}
                    </div>
                    <div class="meta font-12">
                        <a class="mr-1 category-badge" v-for="category in post.categories" :href="category.url">{{ category.name }}</a>
                        <time>{{ post.date }}</time>
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        props: {
            post: Object
        },
        methods: {
            openUrl() {
                this.$root.openUrl(this.post.url);
            }
        }
    }
</script>